/**
 * Page header + underline tabs: a PageHeader over a TabStrip. Use this when
 * the two sit together; if the tabs are separated from the title by other
 * content, compose PageHeader and TabStrip directly instead.
 */

import { PageHeader } from './PageHeader';
import { TabStrip, type TabItem } from './TabStrip';
import './PageTabs.css';

export type PageTab<K extends string = string> = TabItem<K>;

export function PageTabs<K extends string>({
  title,
  subtitle,
  tabs,
  active,
  onChange,
}: {
  title: string;
  subtitle?: string;
  tabs: readonly PageTab<K>[];
  active: K;
  onChange: (key: K) => void;
}) {
  return (
    <div className="app-pagetabs">
      <PageHeader title={title} subtitle={subtitle} />
      <TabStrip tabs={tabs} active={active} onChange={onChange} ariaLabel={title} />
    </div>
  );
}
